import { useNavigate } from 'react-router-dom';

import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

import loginBgDark from 'assets/Images/login/login-bg-dark.jpg';
import loginBgLight from 'assets/Images/login/login-bg-light.jpg';

import PoweredBy from './components/PoweredBy';
import BackButton from './components/BackButton';

import './lib/AuthShell.scss';

const AuthShell = ({ theme = 'light', backTo, onBack, children, className }) => {
  const navigate = useNavigate();
  const isDark = theme === 'dark';
  const handleBack = onBack || (backTo ? () => navigate(backTo) : null);

  return (
    <div
      className={cn(
        'AuthShell',
        isDark ? 'AuthShell--dark bg-neutral-dark-950' : 'bg-primary-600'
      )}>
      <div
        aria-hidden
        className="AuthShell__bg"
        style={{ backgroundImage: `url(${isDark ? loginBgDark : loginBgLight})` }}
      />
      <Icon icon="logo-symbol-white" size={48} className="AuthShell__bandLogo" />
      <div
        className={cn('AuthShell__card', isDark ? 'bg-neutral-dark-900' : 'bg-white', className)}>
        {handleBack && <BackButton isDark={isDark} onClick={handleBack} />}
        <main className="AuthShell__content">
          <div className="AuthShell__inner">{children}</div>
        </main>
        <PoweredBy isDark={isDark} />
      </div>
    </div>
  );
};

export default AuthShell;
